"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var ClientStore = require("../store/ClientList");
var react_router_dom_1 = require("react-router-dom");
var InitPage = /** @class */ (function (_super) {
    __extends(InitPage, _super);
    function InitPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InitPage.prototype.componentDidMount = function () {
        this.props.initializeSession();
    };
    InitPage.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "pt-3 d-flex align-content-center justify-content-around text-center flex-column" },
                React.createElement("div", { className: "spinner-grow align-self-center" }),
                React.createElement("p", { className: "lead" }, "Initializing Synthiam Exosphere Session")),
            React.createElement(react_router_dom_1.Redirect, { to: "/stream/" + this.props.match.params.streamId + "/live" })));
    };
    return InitPage;
}(React.PureComponent));
;
exports.default = react_redux_1.connect(function (state) { return state.clientList; }, ClientStore.actionCreators)(InitPage);
//# sourceMappingURL=Init.js.map